import { SectionHeader } from '@/components/ui/SectionHeader'
import { IncludedGrid } from '@/components/ui/IncludedGrid'
import { included } from '@/data/scans-content'

export const BioScanIncluded = () => (
  <section className="border-t border-base-200 bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-5xl px-6">
      <SectionHeader title="What your" accent="Bio-Scan includes" />
      <IncludedGrid items={included} />
    </div>
  </section>
)
